// frontend/src/offers/OfferBar.jsx
// Slim black announcement bar ("Buy 1 Get 1 Free"). Renders nothing when no offer is live.
// Mount once, as the first child of the sticky wrapper in Navbar.jsx.
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchActiveOffer } from "../../redux/slices/offerSlice";
import { useActiveOffer } from "./useOffer";

const REFRESH_MS = 120000; // pick up offers started / edited / switched off by admin

const OfferBar = () => {
  const dispatch = useDispatch();
  const { offer } = useActiveOffer();

  useEffect(() => {
    const refresh = () => dispatch(fetchActiveOffer());
    const id = setInterval(refresh, REFRESH_MS);
    const onVisible = () => document.visibilityState === "visible" && refresh();
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [dispatch]);

  if (!offer) return null;

  return (
    <>
      <style>{barStyles}</style>
      <div className="ob-bar" role="region" aria-label="Offer">
        <Link to="/bogo" className="ob-text">
          {offer.bannerText || "Buy 1 Get 1 Free"}
        </Link>
      </div>
    </>
  );
};

const barStyles = `
  .ob-bar {
    display: flex; align-items: center; justify-content: center; gap: 18px;
    background: #000; color: #fff; min-height: 34px; padding: 0 16px;
    font-family: 'Exo 2', sans-serif; text-transform: uppercase;
  }
  .ob-text {
    color: #fff; text-decoration: none; font-size: 10px; font-weight: 500; letter-spacing: 0.32em;
  }
  @media (max-width: 480px) {
    .ob-bar { gap: 10px; padding: 0 10px; }
    .ob-text { font-size: 8px; letter-spacing: 0.2em; }
  }
`;

export default OfferBar;
